export default {
  state: {
    assignmentId: '',
    url: '',
  },
  mutations: {
    updateSearchResult: (state: any, res: any) => {
      state.assignmentId = res.assignmentId;
      state.url = res.url;
    },
  },
};
